export default {
    message: {
        contact: {
            companyNameExample: 'ABC Limited',
            stateRegionLabel: 'City',
            ownerNamePlaceholderForCompany: 'Enter the full name of the Company including "Limited"',
        },
    }
};
